export default {
  heading: 'Bad Script, cursive',
  body: 'Noto Sans, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Source Sans Pro Italic, sans-serif',
  googleFonts: ['Bad Script', 'Noto Sans'],
  customFamilies: ['Source Sans Pro Italic'],
  customUrls: ['https://www.gonation.biz/fonts/sourcesanspro/sourcesanspro.css']
}
